import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { documentsResources } from '@releve/documents/i18n';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    ns: ['common', 'dashboard', 'auth', 'forms', 'projects', 'sustainability', 'accounts', 'tables', 'errors', 'timesheets', 'spreadsheet', 'places', 'businesses', 'people', 'memos', 'projectEvents', 'interactions', 'surveys', 'volunteerSignup', 'audit', 'levelUp', 'legal'], // legal: preloaded on purpose — Footer reads it on every page
    defaultNS: 'common',

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

  });

// The `documents` namespace (shared PDF/preview templates) ships as plain objects
// inside @releve/documents rather than as JSON under /locales — the API renders
// the same templates, where there is no /locales to fetch from. Registering the
// bundles here is what makes them available; the namespace is deliberately NOT
// added to `ns` above, because the HTTP backend would then preload
// /locales/{lng}/documents.json and 404 on every language. Namespaces outside
// `ns` are already normal here (`timeclock`); this one simply never hits the
// backend at all.
Object.entries(documentsResources).forEach(([lng, resources]) => {
  i18n.addResourceBundle(lng, 'documents', resources);
});

export default i18n;